import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import * as runReducer from "containers/Run/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as predictReducer from "containers/Predict/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";

import FeatureChartMini from "components/FeatureChart/FeatureChartMini";
import FeatureChartConsumer from "components/FeatureChart/Consumer/FeatureChartConsumer";

class FeatureChartContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    //props.initPredict();
  }

  normalize(val, max, min) {
    return ((val - min) / (max - min)) * 100;
  }

  render() {
    const {
      id,
      isMini,
      isConsumer,
      isRecommend,
      dataset,
      model,
      models,
      fieldSelect,
      valueSelect,
      updateFieldSelect,
      prediction,
      updateValueSelect,
      isForecast,
      getModelFeature
    } = this.props;

    const selectedFeatureBars =
      fieldSelect &&
      model &&
      model.features &&
      model.features.percentages &&
      model.features.percentages[fieldSelect] &&
      model.features.percentages[fieldSelect].values
        ? Object.keys(model.features.percentages[fieldSelect].values)
            .map((value) => ({
              value,
              percentage: model.features.percentages[fieldSelect].values[value]
            }))
            .sort((a, b) => {
              if (model.features.percentages[fieldSelect].index) {
                return (
                  model.features.percentages[fieldSelect].index.indexOf(a.value) -
                  model.features.percentages[fieldSelect].index.indexOf(b.value)
                );
              }
            })
        : [];

    const labelData = {
      label: model && model.label,
      score:
        fieldSelect && model.features.percentages[fieldSelect]
          ? model.features.percentages[fieldSelect].percentage
          : "",
      baseline: model && model.features && model.features.comparison_mean
    };

    const featureBars =
      model && model.featureInfo && model.featureInfo.length > 0
        ? model.featureInfo.map((f) => ({
            left: f.score,
            label: f.label,
            leftModel: model.label,
            values: getModelFeature(model.id, f.label).values
          }))
        : [];

    const modelBars = fieldSelect
      ? models
          .filter((m) => m.featureInfo && m.featureInfo.length > 0)
          .map((m) => ({
            percentage:
              m.featureInfo.filter((f) => f.label === fieldSelect).length > 0
                ? m.featureInfo.filter((f) => f.label === fieldSelect)[0].score
                : -1,
            leftModel: fieldSelect,
            model: m.label,
            modelId: m.id,
            value: fieldSelect,
            field: valueSelect
          }))
          .sort((a, b) => b.left - a.left)
      : [];

    const valueBars = valueSelect
      ? models
          .filter((m) => m.featureInfo && m.featureInfo.length > 0)
          .map((m) => {
            const mFeatures = m.featureInfo.find((f) => f.label === fieldSelect);

            const featureValues = getModelFeature(m.id, fieldSelect).values;

            const valScore = featureValues
              ? Object.keys(featureValues)
                  .filter((vKey) => vKey === valueSelect)
                  .map((vKey) => featureValues[vKey])
              : 0;

            return {
              percentage:
                mFeatures && valScore && valScore.length > 0
                  ? mFeatures.score === 0
                    ? 0
                    : (mFeatures.score / 100) * this.normalize(valScore[0], mFeatures.score, 0) * 100
                  : -1,
              leftModel: valueSelect,
              model: m.label,
              field: fieldSelect,
              value: valueSelect,
              modelId: m.id
            };
          })
          .sort((a, b) => b.left - a.left)
      : undefined;

    return true || isConsumer ? (
      <FeatureChartConsumer
        {...this.props}
        featureBars={featureBars}
        selectedFeatureBars={selectedFeatureBars}
        modelBars={valueBars ? valueBars : modelBars}
        selected={model ? model.id : undefined}
        handleSelect={(label) => updateFieldSelect(label)}
        updateValueSelect={(label) => updateValueSelect(label)}
        field={fieldSelect}
        labelData={labelData}
        rowCount={dataset && dataset.rowCount}
        handlePredict={(scenarioIndex) =>
          this.props.handlePredict(scenarioIndex, isConsumer ? undefined : this.props.model)
        }
      />
    ) : (
      <FeatureChartMini
        {...this.props}
        featureBars={featureBars}
        selectedFeatureBars={selectedFeatureBars}
        modelBars={valueBars ? valueBars : modelBars}
        selected={model ? model.id : undefined}
        handleSelect={(label) => updateFieldSelect(label)}
        updateValueSelect={(label) => updateValueSelect(label)}
        field={fieldSelect}
        labelData={labelData}
        handlePredict={(scenarioIndex) =>
          this.props.handlePredict(scenarioIndex, isConsumer ? undefined : this.props.model)
        }
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleRestfulDeploy: (modelName) => dispatch(deploymentsReducer.handleRestfulDeploy(ownProps.id, modelName)),

  updateSelectedModel: (model) => dispatch(runReducer.updateFeatureSelection(ownProps.id, model, true)),
  updateChooseModel: (model) => dispatch(runReducer.updateChooseModel(ownProps.id, model, true)),
  updateFieldSelect: (fieldSelect) => dispatch(runReducer.updateFieldSelect(ownProps.id, fieldSelect)),
  updateValueSelect: (fieldSelect) => dispatch(runReducer.updateValueSelect(ownProps.id, fieldSelect)),
  updateFeatureSelection: (model) => dispatch(runReducer.updateFeatureSelection(ownProps.id, model, true)),
  updatePredictionDriversMode: (mode) => dispatch(runReducer.updatePredictionDriversMode(ownProps.id, mode)),

  updateIgnored: (column, isIgnored) => dispatch(setupReducer.updateIgnored(ownProps.id, column, isIgnored)),
  updateIgnoredValue: (column, value, isIgnored) =>
    dispatch(setupReducer.updateIgnoredValue(ownProps.id, column, value, isIgnored)),

  updatePredictMode: (predictMode) => dispatch(runReducer.updatePredictMode(ownProps.id, predictMode)),

  updatePredictModels: (predictModels) => dispatch(runReducer.updatePredictModels(ownProps.id, predictModels)),

  handlePredict: (scenarioIndex, model) =>
    dispatch(predictReducer.handlePredict(ownProps.id, ownProps.projectId, scenarioIndex, model)),
  chooseScenario: (scenario) => dispatch(predictReducer.chooseScenario(ownProps.id, scenario)),
  updateScenarioIndex: (scenarioIndex) => dispatch(predictReducer.updateScenarioIndex(ownProps.id, scenarioIndex)),
  updateFieldOption: (field, option) => dispatch(predictReducer.updateFieldOption(ownProps.id, field, option)),
  updateFieldOptions: (options) => dispatch(predictReducer.updateFieldOptions(ownProps.id, options)),
  updateHoverValue: (value) => dispatch(predictReducer.updateHoverValue(ownProps.id, value)),
  resetMinMax: () => dispatch(predictReducer.resetMinMax(ownProps.id)),
  initPredict: () => dispatch(predictReducer.init(ownProps.id)),
  deleteScenario: () => dispatch(predictReducer.deleteCurrentScenario(ownProps.id)),

  updateAllPredictions: () => dispatch(predictReducer.updateAllPredictions(ownProps.id, ownProps.projectId)),

  getModelFeature: (modelId, feature) =>
    dispatch(runReducer.getModelFeatureInfoWithDispatch(ownProps.id, modelId, feature)),
  updateOptimizeBy: (optimizeBy) => dispatch(setupReducer.updateOptimizeBy(ownProps.id, optimizeBy)),
  updateOptimizeGoal: (optimizeGoal) => dispatch(setupReducer.updateOptimizeGoal(ownProps.id, optimizeGoal)),
  updateNOpts: (nOpts) => dispatch(setupReducer.updateNOpts(ownProps.id, nOpts))
});

const mapStateToProps = (state, ownProps) => {
  const projectId =
    ownProps.projectId !== undefined ? ownProps.projectId : projectReducer.getProjectIdFromRunId(state, ownProps.id);

  const currSegment = projectReducer.getSegments(state, projectId)?.find((seg) => seg?.runId === ownProps.id);
  const bestModel = currSegment?.model;

  const projectDeployedScenarioId = projectReducer.getDeployedScenarioIndex(state, projectId);
  const projectViewingScenarioId = projectReducer.getViewingScenarioIndex(state, projectId);

  return {
    models: runReducer.getTransformedSortedModels(state, ownProps.id),
    model: runReducer.getSelModel(state, ownProps.id),

    firstModel:
      bestModel && bestModel?.id ? bestModel : projectReducer.getCapModel(state, ownProps.projectId, ownProps.id, true),
    fieldSelect: runReducer.getFieldSelect(state, ownProps.id),
    valueSelect: runReducer.getValueSelect(state, ownProps.id),
    predictionDriversMode: runReducer.getPredictionDriversMode(state, ownProps.id),
    isPredictLoading: runReducer.getIsPredictLoading(state, ownProps.id),
    predictModels: runReducer.getPredictModels(state, ownProps.id),
    isForecast: setupReducer.getIsForecast(state, ownProps.id),

    isQuickRun: setupReducer.getIsQuickRun(state, ownProps.id),
    fields: setupReducer.getFields(state, ownProps.id),
    fieldValueCounts: setupReducer.getFieldValueCounts(state, ownProps.id),
    ignored: setupReducer.getIgnored(state, ownProps.id),
    ignoredValue: setupReducer.getIgnoredValue(state, ownProps.id),
    successStrings: setupReducer.getSuccessStrings(state, ownProps.id),
    dataset: setupReducer.getDatasetFromSetup(state, ownProps.id),

    isContinuous: setupReducer.getOutcomeType(state, ownProps.id) === "number",
    outcome: setupReducer.getOutcomeFromDataset(state, ownProps.id),
    trueAction: setupReducer.getTrueAction(state, ownProps.id)
      ? setupReducer.getTrueAction(state, ownProps.id)
      : "Pursue transaction",
    falseAction: setupReducer.getFalseAction(state, ownProps.id)
      ? setupReducer.getFalseAction(state, ownProps.id)
      : "Do not pursue transaction",

    prediction: predictReducer.getPrediction(state, ownProps.id),
    scenarios: predictReducer.getScenarios(state, ownProps.id, false, projectId),
    scenarioIndex: predictReducer.getScenarioIndex(state, ownProps.id),
    selectedScenario: predictReducer.getSelectedScenario(state, ownProps.id),

    project: projectReducer.getProject(state, projectId),

    splitColumn: projectReducer.getSplitColumn(state, projectId),

    colSelections: predictReducer.getColumnSelections(state, ownProps.id),
    minMax: predictReducer.getMinMax(state, ownProps.id),

    deployments: deploymentsReducer.getDeploymentsFromJobId(state, ownProps.id),
    projectDeployment: deploymentsReducer.getProjectDeployment(state, projectId),

    isProjectDeployedScenario:
      projectDeployedScenarioId === projectViewingScenarioId &&
      projectReducer.getHasSameScenario(state, projectId, undefined, true),
    projectDeployedScenarioId: projectDeployedScenarioId,
    projectViewingScenarioId: projectViewingScenarioId,

    fieldNames: setupReducer.getFieldNames(state, ownProps.id),

    projectId: projectId,
    optimizeBy: setupReducer.getOptimizeBy(state, ownProps.id),
    optimizeGoal: setupReducer.getOptimizeGoal(state, ownProps.id),
    nOpts: setupReducer.getNOpts(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(FeatureChartContainer);
